/* eslint-disable import/no-anonymous-default-export */
import { AntennaList } from './list/AntennaList';
import { AntennaCreate } from './edit/AntennaCreate';
import { AntennaShow } from './show/AntennaShow';
import { AntennaEdit } from './edit/AntennaEdit';

export default {
    list: AntennaList,
    create: AntennaCreate,
    edit: AntennaEdit,
    show: AntennaShow,
};
